// Job/assignment status filter options. Swatches match the status legend in
// DispatchViewBar (.assigned-color etc. in styles/index.scss).
export const jobStatusOptions = () => [
  { label: "Assigned", value: "assigned", selected: false, swatch: "#fe4c52" },
  { label: "Confirmed", value: "confirmed", selected: false, swatch: "#b7c300" },
  { label: "In Progress", value: "in_progress", selected: false, swatch: "#a6e22e" },
  { label: "Completed", value: "completed", selected: false, swatch: "#387ef5" },
  { label: "Unassigned", value: "unassigned", selected: false, swatch: "#cccccc" }
];
